import { Link, useLocation } from 'react-router-dom'

const navItems = [
  { name: 'Hlavní přehled', link: 'dashboard' },
  { name: 'Rezervace', link: 'reservations' },
  { name: 'Objednávky', link: 'orders' },
  { name: 'Poptávky', link: 'requests' },
  { name: 'Úschovy', link: 'storages' },
  { name: 'Nová objednávka', link: 'ordercreate' },
  { name: 'Změna objednávky', link: 'orderupdate' },
  { name: 'Střediska', link: 'departments' },
  { name: 'Uživatelé', link: 'users' },
  { name: 'Nastavení', link: 'settings' },
  { name: 'Uživatelský profil', link: 'profile' }
]

const Breadcrumbs = () => {
  const location = useLocation()
  const pathnames = location.pathname.split('/').filter((x) => x)

  if (pathnames.length === 0) return null

  if (location.pathname === '/reservations/search') {
    return (
      <>
        <h2 className="mb-0">Vyhledávání rezervací</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/dashboard"><i className="bi bi-house"></i></Link></li>
            <li className="breadcrumb-item"><Link to="/reservations" className="text-decoration-none">Rezervace</Link></li>
          </ol>
        </nav>
      </>
    )
  }

  if (location.pathname === '/storagedetail') {
    return (
      <>
        <h2 className="mb-0">Karta vozidla</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/dashboard"><i className="bi bi-house"></i></Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/storages" className="text-decoration-none">Úschovy</Link>
            </li>
          </ol>
        </nav>
      </>
    )
  }

  if (location.pathname === '/ordercreate' || location.pathname === '/orderupdate') {
    const orderTitle = location.pathname === '/ordercreate' ? 'Nová objednávka' : 'Úprava objednávky'
    return (
      <>
        <h2 className="mb-0">{orderTitle}</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/dashboard"><i className="bi bi-house"></i></Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/orders" className="text-decoration-none">Objednávky</Link>
            </li>
          </ol>
        </nav>
      </>
    )
  }

  const findNavName = (pathname) => {
    const item = navItems.find((navItem) => pathname === navItem.link)
    return item ? item.name : pathname.charAt(0).toUpperCase() + pathname.slice(1)
  }

  const lastSegment = pathnames[pathnames.length - 1]

  return (
    <>
      <h2 className="mb-0">{findNavName(lastSegment)}</h2>
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/"><i className="bi bi-house"></i></Link>
          </li>
          {pathnames.map((value, index) => {
            const to = `/${pathnames.slice(0, index + 1).join('/')}`
            const isLast = index === pathnames.length - 1
            return (
              <li className={`breadcrumb-item${isLast ? ' active' : ''}`} aria-current={isLast ? 'page' : undefined} key={to}>
                {isLast ? (
                  findNavName(value)
                ) : (
                  <Link to={to} className='text-decoration-none'>{findNavName(value)}</Link>
                )}
              </li>
            )
          })}
        </ol>
      </nav>
    </>
  )
}

export default Breadcrumbs

